export default __webpack_public_path__ + "static/media/tagHomerSeleto.ee96d1e4.svg";